import {
  buildRolloverStudentsCsvApiValidateUrl,
  buildRolloverStudentsCsvApiValidateResultUrl,
  buildRolloverStudentsCsvApiImportUrl,
} from 'teacher-ui-client/utils/import-students-csv-urls'

export const validateUrl = buildRolloverStudentsCsvApiValidateUrl({
  subscriptionType: 'reading',
})

export const validateResultUrl = buildRolloverStudentsCsvApiValidateResultUrl({
  subscriptionType: 'reading',
})

export const importUrl = buildRolloverStudentsCsvApiImportUrl({
  subscriptionType: 'reading',
})

export const urls = {
  validateUrl,
  validateResultUrl,
  importUrl,
}
